module.exports = __webpack_public_path__ + "img/longball-logo-small.4226ba13.svg";